// Team Badge Component - Gradient-bordered circles with abbreviations
const TeamIcon = ({ team, size = "md" }) => {
  // Team abbreviation and gradient color mapping
  const TEAM_CONFIG = {
    Mumbai: { abbr: "MUM", gradient: ["#2563EB", "#60A5FA"] },
    Chennai: { abbr: "CHN", gradient: ["#FACC15", "#FDE68A"] },
    Rajasthan: { abbr: "RAJ", gradient: ["#E11D48", "#FB7185"] },
    Punjab: { abbr: "PUN", gradient: ["#F97316", "#FDBA74"] },
    Delhi: { abbr: "DEL", gradient: ["#2563EB", "#93C5FD"] },
    Hyderabad: { abbr: "HYD", gradient: ["#F97316", "#FDBA74"] },
    Lucknow: { abbr: "LCK", gradient: ["#06B6D4", "#67E8F9"] },
    Bangalore: { abbr: "BLR", gradient: ["#DC2626", "#F87171"] },
    Gujarat: { abbr: "GUJ", gradient: ["#0284C7", "#7DD3FC"] },
    Kolkata: { abbr: "KOL", gradient: ["#9333EA", "#C084FC"] },
  };

  const config = TEAM_CONFIG[team] || {
    abbr: team?.slice(0, 3)?.toUpperCase() || "TBD",
    gradient: ["#6B7280", "#9CA3AF"],
  };
  const { abbr, gradient } = config;

  const sizeConfig =
    size === "sm"
      ? { outer: "w-10 h-10", inner: "w-[38px] h-[38px]", text: "text-[9px]" }
      : { outer: "w-12 h-12", inner: "w-[46px] h-[46px]", text: "text-[11px]" };

  return (
    <div
      className={`${sizeConfig.outer} rounded-full flex items-center justify-center flex-shrink-0`}
      style={{
        background: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`,
        padding: "1.5px",
      }}
    >
      <div
        className={`${sizeConfig.inner} rounded-full flex items-center justify-center`}
        style={{ background: "#0f0f0f" }}
      >
        <span
          className={`${sizeConfig.text} font-bold bg-clip-text text-transparent`}
          style={{
            backgroundImage: `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})`,
          }}
        >
          {abbr}
        </span>
      </div>
    </div>
  );
};

export default TeamIcon;
